import { styled } from '@mui/material/styles';
import { DropdownTextContainer } from '../../../pages/rbf/rbf-personal-data/components/ClientWealthMultiSelect/ClientWealthMultiSelect.css';

export const DropdownFieldContainer = styled(DropdownTextContainer)({
    width: '95%'
})
